// extracted by mini-css-extract-plugin
export default {"article":"GuideArticle_article__ZnrSQ","addToBook":"GuideArticle_addToBook__zbAs0","loader":"GuideArticle_loader__nsFii","componentNotFound":"GuideArticle_componentNotFound__Tk9ht"};